import styled from 'styled-components';
import { Alert, TextButton } from '@shopline/dashboard-ui';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

export const EnhancedWarningAlert = styled(Alert.Warning)`
  margin-bottom: 24px;
`;

export const FormContainer = styled.div`
  flex: 1;

  h4 {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    vertical-align: middle;
    color: ${({ theme }) => theme.colors.INK_800};
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    margin: 0;
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.INK_600};
  }

  ${EnhancedWarningAlert} {
    margin-bottom: 16px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Image = styled.img`
  width: 100%;
  max-width: 220px;
`;

export const ActionBtns = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleWithLogo = styled.h3`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.INK_600};

  .logo {
    display: flex;
    align-items: center;
    margin-right: 12px;
    gap: 4px;
  }
`;

export const LoggedInContainer = styled.div`
  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    margin: 0;
    margin-bottom: 4px;

    color: ${({ theme }) => theme.colors.INK_800};
  }
`;

export const EmailContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LogoutContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoutButton = styled(TextButton.Dark)`
  & {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.INK_500};
  }

  > svg {
    transform: scaleX(-1);
  }
`;
